import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Datetime from "react-datetime";
import Select from "react-select";
import axios from "axios";

import routes from "app/routes";
import policy_invoice_statuses from "data/policy_invoice_statuses";

export default function Filters({
  keyword,
  setKeyword,
  filterDate,
  setFilterDate,
  filterStatus,
  setFilterStatus,
}) {
  const [loading, setLoading] = useState(false);

  const sendReport = () => {
    setLoading(true);

    axios
      .get(routes.admin.policy_billings.report)
      .then((resp) => {
        swal({
          title: "",
          text: "Policy Billing Report will be updated soon. Please, open Google Sheet and check the update in a couple of minutes.",
        });
        setLoading(false);
      });
  };

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Col>

        <Col md={3}>
          <Datetime
            inputProps={{ placeholder: "Date" }}
            value={filterDate != null ? filterDate : ""}
            timeFormat={false}
            onChange={(date) => setFilterDate(date)}
            renderInput={(props) => {
              return (
                <input
                  {...props}
                  value={
                    filterDate != null
                      ? typeof filterDate == "string"
                        ? filterDate
                        : filterDate.format("MM/DD/YYYY")
                      : ""
                  }
                />
              );
            }}
          />
        </Col>

        <Col md={3}>
          <Select
            value={filterStatus}
            onChange={(item) => setFilterStatus(item)}
            placeholder="Status"
            options={policy_invoice_statuses}
            isClearable={true}
          />
        </Col>

        <Col md={3} className="text-right">
          <Button
            bsStyle="primary"
            disabled={loading}
            onClick={sendReport}
          >
            Report
          </Button>
        </Col>
      </Row>
    </div>
  );
}
